<script setup lang="ts">
  import { computed } from 'vue';
  import { getSerpCardLeadBannerContext, type LeadBannerTrackingContext } from '@/entities/analytics';
  import type { Product } from '@/entities/product';
  import type { SearchCriteria } from '@/entities/searchCriteria';
  import { LeadBanner } from '@/features/leadBanner';
  import { SERP_LEAD_BANNER_TEXTS } from '../config/texts';

  interface SerpLeadBannerProps {
    product: Product;
    searchCriteria: SearchCriteria;
    cardPosition: number;
  }

  const props = defineProps<SerpLeadBannerProps>();

  const tracking = computed<LeadBannerTrackingContext>(() => getSerpCardLeadBannerContext(props.cardPosition));
</script>

<template>
  <LeadBanner
    :title="SERP_LEAD_BANNER_TEXTS.title"
    :subtitle="SERP_LEAD_BANNER_TEXTS.subtitle"
    :button-text="SERP_LEAD_BANNER_TEXTS.button"
    :mobile="true"
    :tracking="tracking"
    data-testid="serp-lead-banner"
  />
</template>
